var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapacityIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_2178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.26 6.50405C15.3466 6.50405 16.2274 5.62318 16.2274 4.53657C16.2274 3.44996 15.3466 2.56909 14.26 2.56909C13.1734 2.56909 12.2925 3.44996 12.2925 4.53657C12.2925 5.62318 13.1734 6.50405 14.26 6.50405Z",
    stroke: "#515151",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1219 9.35764H11.4065C11.4065 7.7804 12.6829 6.49585 14.2683 6.49585C15.8536 6.49585 17.1301 7.77227 17.1301 9.35764H17.1219Z",
    stroke: "#515151",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7397 6.52041C6.82631 6.52041 7.70718 5.63954 7.70718 4.55293C7.70718 3.46632 6.82631 2.58545 5.7397 2.58545C4.65309 2.58545 3.77222 3.46632 3.77222 4.55293C3.77222 5.63954 4.65309 6.52041 5.7397 6.52041Z",
    stroke: "#515151",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.26 17.4308C15.3466 17.4308 16.2274 16.5499 16.2274 15.4633C16.2274 14.3767 15.3466 13.4958 14.26 13.4958C13.1734 13.4958 12.2925 14.3767 12.2925 15.4633C12.2925 16.5499 13.1734 17.4308 14.26 17.4308Z",
    stroke: "#515151",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7397 14.3578C6.82631 14.3578 7.70718 13.4769 7.70718 12.3903C7.70718 11.3037 6.82631 10.4229 5.7397 10.4229C4.65309 10.4229 3.77222 11.3037 3.77222 12.3903C3.77222 13.4769 4.65309 14.3578 5.7397 14.3578Z",
    stroke: "#515151",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59338 17.2114H2.87793C2.87793 15.6342 4.15435 14.3496 5.73972 14.3496C7.32508 14.3496 8.60151 15.626 8.60151 17.2114H8.59338Z",
    stroke: "#515151",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1463 0.406494H1.85365C1.05441 0.406494 0.406494 1.05441 0.406494 1.85365V18.1463C0.406494 18.9456 1.05441 19.5935 1.85365 19.5935H18.1463C18.9456 19.5935 19.5935 18.9456 19.5935 18.1463V1.85365C19.5935 1.05441 18.9456 0.406494 18.1463 0.406494Z",
    stroke: "#515151",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_2178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacityIconBlack);
export default __webpack_public_path__ + "static/media/CapacityIconBlack.9d55e0f1d7fd76ef75dfcc4c3c80369b.svg";
export { ForwardRef as ReactComponent };